import { createAction, props } from '@ngrx/store';
import { PlantListInterface } from 'src/app/pages/record/interfaces';

export const loadPlantListCompanyByUserGuid = createAction('[PlantListCompanyByUserGuid] Load');
export const loadPlantListCompanyByUserGuidSuccess = createAction(
  '[PlantListCompanyByUserGuid] Load Success',
  props<{ userGuid: string; plants: PlantListInterface[] }>(),
);
export const loadPlantListCompanyByUserGuidFailure = createAction(
  '[PlantListCompanyByUserGuid] Load Failure',
  props<{ error: string }>(),
);
export const resetPlantListCompanyByUserGuid = createAction('[PlantListCompanyByUserGuid] Reset');
export const refreshPlantListCompanyByUserGuid = createAction('[PlantListCompanyByUserGuid] Refresh');
